import React from 'react';

const Tools = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-slate-900 mb-6">Herramientas PDF</h1>
      <div className="bg-white rounded-2xl p-6 shadow-lg border border-slate-200">
        <p className="text-slate-600">Configuración de herramientas PDF</p>
      </div>
    </div>
  );
};

export default Tools;